import { useState } from "react";

import { Button, ModalDelete } from "expano-components";

import { Main, PageLoader, Error } from "components";
import useGet from "hooks/useGet";
import useDelete from "hooks/useDelete";

import { ReactComponent as ShopIcon } from "icons/shop.svg";

import BasicData from "./components/BasicData";
import ExchangeRates from "./components/ExchangeRates";

const CurrencyEdit = ({
  match: {
    params: { id },
  },
  history,
}) => {
  const [show_delete_modal, setShowDeleteModal] = useState(false);

  const {
    is_loading,
    is_error,
    error,
    data: currency,
    refetch,
  } = useGet({
    query: ["currency", id],
    path: `/currencies/${id}`,
    context: "ui_show",
  });

  const { is_deleting, _delete } = useDelete({
    path: `/currencies/${id}`,
    onSuccess: () => history.push("/currencies"),
  });

  if (is_loading) {
    return <PageLoader />;
  }

  if (is_error) {
    return <Error message={error} />;
  }

  return (
    <Main
      page={{
        name: currency?.name,
        icon: <ShopIcon />,
        breadcrumbs: [
          {
            name: "Waluty",
            path: "/currencies",
          },
          { name: currency?.name },
        ],
        buttons: (
          <Button
            type="delete"
            text="Usuń walutę"
            disabled={is_deleting}
            onClick={() => setShowDeleteModal(true)}
          />
        ),
      }}
    >
      {show_delete_modal && (
        <ModalDelete
          handleDelete={_delete}
          handleClose={() => setShowDeleteModal(false)}
          name={`walutę ${currency?.name}?`}
        />
      )}
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <BasicData
            currency_id={id}
            refetch={refetch}
            initialValues={{
              name: currency?.name,
              identifier: currency?.identifier,
              default_suggested_price_exchange_rate:
                currency?.default_suggested_price_exchange_rate,
            }}
          />
        </div>
        <div className="column-half">
          <ExchangeRates exchange_rates={currency?.exchange_rates} />
        </div>
      </div>
    </Main>
  );
};

export default CurrencyEdit;
